import { VaultPropertyColor } from '../../../../../../../shared/entities/VaultProperty';

export function getRandomPropertyColor() {
  return Object.values(VaultPropertyColor)[
    Math.floor(Math.random() * Object.values(VaultPropertyColor).length)
  ];
}
